import * as i0 from '@angular/core';
import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var CategoryClass = /*#__PURE__*/function (CategoryClass) {
  CategoryClass[CategoryClass["CATEGORY_CLASS_CONCRETE"] = 0] = "CATEGORY_CLASS_CONCRETE";
  CategoryClass[CategoryClass["CATEGORY_CLASS_ABSTRACT"] = 1] = "CATEGORY_CLASS_ABSTRACT";
  return CategoryClass;
}(CategoryClass || {});
var CategoryType = /*#__PURE__*/function (CategoryType) {
  CategoryType[CategoryType["CATEGORY_TYPE_V_CATEGORY"] = 0] = "CATEGORY_TYPE_V_CATEGORY";
  CategoryType[CategoryType["CATEGORY_TYPE_V_TAX"] = 1] = "CATEGORY_TYPE_V_TAX";
  CategoryType[CategoryType["CATEGORY_TYPE_GOOGLE_PLACES"] = 2] = "CATEGORY_TYPE_GOOGLE_PLACES";
  CategoryType[CategoryType["CATEGORY_TYPE_GMB"] = 3] = "CATEGORY_TYPE_GMB";
  CategoryType[CategoryType["CATEGORY_TYPE_UBERALL"] = 4] = "CATEGORY_TYPE_UBERALL";
  CategoryType[CategoryType["CATEGORY_TYPE_YEXT"] = 5] = "CATEGORY_TYPE_YEXT";
  CategoryType[CategoryType["CATEGORY_TYPE_BING"] = 6] = "CATEGORY_TYPE_BING";
  CategoryType[CategoryType["CATEGORY_TYPE_DATA_AXLE"] = 7] = "CATEGORY_TYPE_DATA_AXLE";
  CategoryType[CategoryType["CATEGORY_TYPE_FOURSQUARE"] = 9] = "CATEGORY_TYPE_FOURSQUARE";
  CategoryType[CategoryType["CATEGORY_TYPE_LOCALEZE"] = 10] = "CATEGORY_TYPE_LOCALEZE";
  CategoryType[CategoryType["CATEGORY_TYPE_NEUSTAR"] = 11] = "CATEGORY_TYPE_NEUSTAR";
  CategoryType[CategoryType["CATEGORY_TYPE_APPLE"] = 12] = "CATEGORY_TYPE_APPLE";
  CategoryType[CategoryType["CATEGORY_TYPE_APPLE_2"] = 13] = "CATEGORY_TYPE_APPLE_2";
  CategoryType[CategoryType["CATEGORY_TYPE_EZLOCAL"] = 14] = "CATEGORY_TYPE_EZLOCAL";
  return CategoryType;
}(CategoryType || {});
var Locale = /*#__PURE__*/function (Locale) {
  Locale[Locale["LOCALE_UNSET"] = 0] = "LOCALE_UNSET";
  Locale[Locale["LOCALE_AFRIKAANS"] = 1] = "LOCALE_AFRIKAANS";
  Locale[Locale["LOCALE_CZECH"] = 2] = "LOCALE_CZECH";
  Locale[Locale["LOCALE_DUTCH"] = 3] = "LOCALE_DUTCH";
  Locale[Locale["LOCALE_ENGLISH"] = 4] = "LOCALE_ENGLISH";
  Locale[Locale["LOCALE_FRENCH"] = 5] = "LOCALE_FRENCH";
  Locale[Locale["LOCALE_FRENCH_CANADA"] = 6] = "LOCALE_FRENCH_CANADA";
  Locale[Locale["LOCALE_GERMAN"] = 7] = "LOCALE_GERMAN";
  Locale[Locale["LOCALE_ITALIAN"] = 8] = "LOCALE_ITALIAN";
  Locale[Locale["LOCALE_JAPANESE"] = 9] = "LOCALE_JAPANESE";
  Locale[Locale["LOCALE_PORTUGUESE_BRAZIL"] = 10] = "LOCALE_PORTUGUESE_BRAZIL";
  Locale[Locale["LOCALE_RUSSIAN"] = 11] = "LOCALE_RUSSIAN";
  Locale[Locale["LOCALE_SPANISH_LATIN_AMERICA"] = 12] = "LOCALE_SPANISH_LATIN_AMERICA";
  return Locale;
}(Locale || {});
var SortDirection = /*#__PURE__*/function (SortDirection) {
  SortDirection[SortDirection["SORT_DIRECTION_UNSET"] = 0] = "SORT_DIRECTION_UNSET";
  SortDirection[SortDirection["SORT_DIRECTION_ASCENDING"] = 1] = "SORT_DIRECTION_ASCENDING";
  SortDirection[SortDirection["SORT_DIRECTION_DESCENDING"] = 2] = "SORT_DIRECTION_DESCENDING";
  return SortDirection;
}(SortDirection || {});
var SortField = /*#__PURE__*/function (SortField) {
  SortField[SortField["SORT_FIELD_UNSET"] = 0] = "SORT_FIELD_UNSET";
  SortField[SortField["SORT_FIELD_NAME"] = 1] = "SORT_FIELD_NAME";
  SortField[SortField["SORT_FIELD_FULL_NAME"] = 2] = "SORT_FIELD_FULL_NAME";
  SortField[SortField["SORT_FIELD_SCORE"] = 3] = "SORT_FIELD_SCORE";
  SortField[SortField["SORT_FIELD_EXTERNAL_ID"] = 4] = "SORT_FIELD_EXTERNAL_ID";
  SortField[SortField["SORT_FIELD_CREATED"] = 5] = "SORT_FIELD_CREATED";
  SortField[SortField["SORT_FIELD_UPDATED"] = 6] = "SORT_FIELD_UPDATED";
  return SortField;
}(SortField || {});
var TypeCategoryRelationship = /*#__PURE__*/function (TypeCategoryRelationship) {
  TypeCategoryRelationship[TypeCategoryRelationship["TYPE_CATEGORY_RELATIONSHIP_EXACT_MATCH"] = 0] = "TYPE_CATEGORY_RELATIONSHIP_EXACT_MATCH";
  TypeCategoryRelationship[TypeCategoryRelationship["TYPE_CATEGORY_RELATIONSHIP_GOOD_MATCH"] = 1] = "TYPE_CATEGORY_RELATIONSHIP_GOOD_MATCH";
  TypeCategoryRelationship[TypeCategoryRelationship["TYPE_CATEGORY_RELATIONSHIP_OK_MATCH"] = 2] = "TYPE_CATEGORY_RELATIONSHIP_OK_MATCH";
  return TypeCategoryRelationship;
}(TypeCategoryRelationship || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums Index.
// *********************************

function enumStringToValue$3(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class FieldMask {
  static fromProto(proto) {
    let m = new FieldMask();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.paths !== 'undefined') {
      toReturn['paths'] = this.paths;
    }
    return toReturn;
  }
}
function enumStringToValue$2(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class Access {
  static fromProto(proto) {
    let m = new Access();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.scope !== 'undefined') {
      toReturn['scope'] = this.scope;
    }
    if (typeof this.public !== 'undefined') {
      toReturn['public'] = this.public;
    }
    return toReturn;
  }
}
function enumStringToValue$1(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class PagedRequestOptions {
  static fromProto(proto) {
    let m = new PagedRequestOptions();
    m = Object.assign(m, proto);
    if (proto.pageSize) {
      m.pageSize = parseInt(proto.pageSize, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    if (typeof this.pageSize !== 'undefined') {
      toReturn['pageSize'] = this.pageSize;
    }
    return toReturn;
  }
}
class PagedResponseMetadata {
  static fromProto(proto) {
    let m = new PagedResponseMetadata();
    m = Object.assign(m, proto);
    if (proto.totalResults) {
      m.totalResults = parseInt(proto.totalResults, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.nextCursor !== 'undefined') {
      toReturn['nextCursor'] = this.nextCursor;
    }
    if (typeof this.hasMore !== 'undefined') {
      toReturn['hasMore'] = this.hasMore;
    }
    if (typeof this.totalResults !== 'undefined') {
      toReturn['totalResults'] = this.totalResults;
    }
    return toReturn;
  }
}
function enumStringToValue(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class BulkCreateCategoriesRequest {
  static fromProto(proto) {
    let m = new BulkCreateCategoriesRequest();
    m = Object.assign(m, proto);
    if (proto.categories) {
      m.categories = proto.categories.map(Category.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.categories !== 'undefined' && this.categories !== null) {
      toReturn['categories'] = 'toApiJson' in this.categories ? this.categories.toApiJson() : this.categories;
    }
    return toReturn;
  }
}
class BulkCreateCategoryRelationshipsRequest {
  static fromProto(proto) {
    let m = new BulkCreateCategoryRelationshipsRequest();
    m = Object.assign(m, proto);
    if (proto.categoryRelationships) {
      m.categoryRelationships = proto.categoryRelationships.map(CategoryRelationships.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.categoryRelationships !== 'undefined' && this.categoryRelationships !== null) {
      toReturn['categoryRelationships'] = 'toApiJson' in this.categoryRelationships ? this.categoryRelationships.toApiJson() : this.categoryRelationships;
    }
    return toReturn;
  }
}
class BulkDeleteCategoryRelationshipsRequest {
  static fromProto(proto) {
    let m = new BulkDeleteCategoryRelationshipsRequest();
    m = Object.assign(m, proto);
    if (proto.type) {
      m.type = enumStringToValue(CategoryType, proto.type);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.type !== 'undefined') {
      toReturn['type'] = this.type;
    }
    return toReturn;
  }
}
class Category {
  static fromProto(proto) {
    let m = new Category();
    m = Object.assign(m, proto);
    if (proto.type) {
      m.type = enumStringToValue(CategoryType, proto.type);
    }
    if (proto.class) {
      m.class = enumStringToValue(CategoryClass, proto.class);
    }
    if (proto.locale) {
      m.locale = CategoryLocale.fromProto(proto.locale);
    }
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.updated) {
      m.updated = new Date(proto.updated);
    }
    if (proto.translations) {
      m.translations = proto.translations.map(CategoryTranslation.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.categoryId !== 'undefined') {
      toReturn['categoryId'] = this.categoryId;
    }
    if (typeof this.externalId !== 'undefined') {
      toReturn['externalId'] = this.externalId;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.type !== 'undefined') {
      toReturn['type'] = this.type;
    }
    if (typeof this.class !== 'undefined') {
      toReturn['class'] = this.class;
    }
    if (typeof this.locale !== 'undefined' && this.locale !== null) {
      toReturn['locale'] = 'toApiJson' in this.locale ? this.locale.toApiJson() : this.locale;
    }
    if (typeof this.isHidden !== 'undefined') {
      toReturn['isHidden'] = this.isHidden;
    }
    if (typeof this.isActive !== 'undefined') {
      toReturn['isActive'] = this.isActive;
    }
    if (typeof this.fullName !== 'undefined') {
      toReturn['fullName'] = this.fullName;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.updated !== 'undefined' && this.updated !== null) {
      toReturn['updated'] = 'toApiJson' in this.updated ? this.updated.toApiJson() : this.updated;
    }
    if (typeof this.translations !== 'undefined' && this.translations !== null) {
      toReturn['translations'] = 'toApiJson' in this.translations ? this.translations.toApiJson() : this.translations;
    }
    return toReturn;
  }
}
class CategoryLocale {
  static fromProto(proto) {
    let m = new CategoryLocale();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.country !== 'undefined') {
      toReturn['country'] = this.country;
    }
    if (typeof this.language !== 'undefined') {
      toReturn['language'] = this.language;
    }
    return toReturn;
  }
}
class CategoryPagedRequestOptions {
  static fromProto(proto) {
    let m = new CategoryPagedRequestOptions();
    m = Object.assign(m, proto);
    if (proto.pageSize) {
      m.pageSize = parseInt(proto.pageSize, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    if (typeof this.pageSize !== 'undefined') {
      toReturn['pageSize'] = this.pageSize;
    }
    return toReturn;
  }
}
class CategoryPagedResponseMetadata {
  static fromProto(proto) {
    let m = new CategoryPagedResponseMetadata();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.nextCursor !== 'undefined') {
      toReturn['nextCursor'] = this.nextCursor;
    }
    if (typeof this.hasMore !== 'undefined') {
      toReturn['hasMore'] = this.hasMore;
    }
    return toReturn;
  }
}
class CategoryRelationship {
  static fromProto(proto) {
    let m = new CategoryRelationship();
    m = Object.assign(m, proto);
    if (proto.category) {
      m.category = Category.fromProto(proto.category);
    }
    if (proto.relationship) {
      m.relationship = enumStringToValue(TypeCategoryRelationship, proto.relationship);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.category !== 'undefined' && this.category !== null) {
      toReturn['category'] = 'toApiJson' in this.category ? this.category.toApiJson() : this.category;
    }
    if (typeof this.relationship !== 'undefined') {
      toReturn['relationship'] = this.relationship;
    }
    return toReturn;
  }
}
class CategoryRelationships {
  static fromProto(proto) {
    let m = new CategoryRelationships();
    m = Object.assign(m, proto);
    if (proto.originCategory) {
      m.originCategory = enumStringToValue(CategoryType, proto.originCategory);
    }
    if (proto.targetCategory) {
      m.targetCategory = enumStringToValue(CategoryType, proto.targetCategory);
    }
    if (proto.typeCategoryRelationship) {
      m.typeCategoryRelationship = enumStringToValue(TypeCategoryRelationship, proto.typeCategoryRelationship);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.originId !== 'undefined') {
      toReturn['originId'] = this.originId;
    }
    if (typeof this.targetId !== 'undefined') {
      toReturn['targetId'] = this.targetId;
    }
    if (typeof this.originCategory !== 'undefined') {
      toReturn['originCategory'] = this.originCategory;
    }
    if (typeof this.targetCategory !== 'undefined') {
      toReturn['targetCategory'] = this.targetCategory;
    }
    if (typeof this.typeCategoryRelationship !== 'undefined') {
      toReturn['typeCategoryRelationship'] = this.typeCategoryRelationship;
    }
    if (typeof this.humanVerified !== 'undefined') {
      toReturn['humanVerified'] = this.humanVerified;
    }
    return toReturn;
  }
}
class CategoryRequest {
  static fromProto(proto) {
    let m = new CategoryRequest();
    m = Object.assign(m, proto);
    if (proto.categoryType) {
      m.categoryType = enumStringToValue(CategoryType, proto.categoryType);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.externalId !== 'undefined') {
      toReturn['externalId'] = this.externalId;
    }
    if (typeof this.categoryType !== 'undefined') {
      toReturn['categoryType'] = this.categoryType;
    }
    return toReturn;
  }
}
class CategorySearchRequest {
  static fromProto(proto) {
    let m = new CategorySearchRequest();
    m = Object.assign(m, proto);
    if (proto.type) {
      m.type = enumStringToValue(CategoryType, proto.type);
    }
    if (proto.pagingOptions) {
      m.pagingOptions = PagedRequestOptions.fromProto(proto.pagingOptions);
    }
    if (proto.sortOptions) {
      m.sortOptions = proto.sortOptions.map(SortOptions.fromProto);
    }
    if (proto.languageAndLocale) {
      m.languageAndLocale = enumStringToValue(Locale, proto.languageAndLocale);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.searchTerm !== 'undefined') {
      toReturn['searchTerm'] = this.searchTerm;
    }
    if (typeof this.locale !== 'undefined') {
      toReturn['locale'] = this.locale;
    }
    if (typeof this.type !== 'undefined') {
      toReturn['type'] = this.type;
    }
    if (typeof this.pagingOptions !== 'undefined' && this.pagingOptions !== null) {
      toReturn['pagingOptions'] = 'toApiJson' in this.pagingOptions ? this.pagingOptions.toApiJson() : this.pagingOptions;
    }
    if (typeof this.sortOptions !== 'undefined' && this.sortOptions !== null) {
      toReturn['sortOptions'] = 'toApiJson' in this.sortOptions ? this.sortOptions.toApiJson() : this.sortOptions;
    }
    if (typeof this.onlyVisible !== 'undefined') {
      toReturn['onlyVisible'] = this.onlyVisible;
    }
    if (typeof this.languageAndLocale !== 'undefined') {
      toReturn['languageAndLocale'] = this.languageAndLocale;
    }
    return toReturn;
  }
}
class CategorySearchResponse {
  static fromProto(proto) {
    let m = new CategorySearchResponse();
    m = Object.assign(m, proto);
    if (proto.category) {
      m.category = proto.category.map(Category.fromProto);
    }
    if (proto.pagingMetadata) {
      m.pagingMetadata = PagedResponseMetadata.fromProto(proto.pagingMetadata);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.category !== 'undefined' && this.category !== null) {
      toReturn['category'] = 'toApiJson' in this.category ? this.category.toApiJson() : this.category;
    }
    if (typeof this.pagingMetadata !== 'undefined' && this.pagingMetadata !== null) {
      toReturn['pagingMetadata'] = 'toApiJson' in this.pagingMetadata ? this.pagingMetadata.toApiJson() : this.pagingMetadata;
    }
    return toReturn;
  }
}
class CategoryTranslation {
  static fromProto(proto) {
    let m = new CategoryTranslation();
    m = Object.assign(m, proto);
    if (proto.locale) {
      m.locale = enumStringToValue(Locale, proto.locale);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.locale !== 'undefined') {
      toReturn['locale'] = this.locale;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.fullName !== 'undefined') {
      toReturn['fullName'] = this.fullName;
    }
    return toReturn;
  }
}
class CreateCategoryRequest {
  static fromProto(proto) {
    let m = new CreateCategoryRequest();
    m = Object.assign(m, proto);
    if (proto.type) {
      m.type = enumStringToValue(CategoryType, proto.type);
    }
    if (proto.translations) {
      m.translations = proto.translations.map(CategoryTranslation.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.fullName !== 'undefined') {
      toReturn['fullName'] = this.fullName;
    }
    if (typeof this.externalId !== 'undefined') {
      toReturn['externalId'] = this.externalId;
    }
    if (typeof this.type !== 'undefined') {
      toReturn['type'] = this.type;
    }
    if (typeof this.isHidden !== 'undefined') {
      toReturn['isHidden'] = this.isHidden;
    }
    if (typeof this.isActive !== 'undefined') {
      toReturn['isActive'] = this.isActive;
    }
    if (typeof this.translations !== 'undefined' && this.translations !== null) {
      toReturn['translations'] = 'toApiJson' in this.translations ? this.translations.toApiJson() : this.translations;
    }
    return toReturn;
  }
}
class CreateCategoryResponse {
  static fromProto(proto) {
    let m = new CreateCategoryResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.categoryId !== 'undefined') {
      toReturn['categoryId'] = this.categoryId;
    }
    return toReturn;
  }
}
class DeleteCategoryByExternalIDAndTypeRequest {
  static fromProto(proto) {
    let m = new DeleteCategoryByExternalIDAndTypeRequest();
    m = Object.assign(m, proto);
    if (proto.categoryType) {
      m.categoryType = enumStringToValue(CategoryType, proto.categoryType);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.externalId !== 'undefined') {
      toReturn['externalId'] = this.externalId;
    }
    if (typeof this.categoryType !== 'undefined') {
      toReturn['categoryType'] = this.categoryType;
    }
    return toReturn;
  }
}
class DeleteCategoryRelationshipByExternalIDAndTypeRequest {
  static fromProto(proto) {
    let m = new DeleteCategoryRelationshipByExternalIDAndTypeRequest();
    m = Object.assign(m, proto);
    if (proto.categoryType) {
      m.categoryType = enumStringToValue(CategoryType, proto.categoryType);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.externalId !== 'undefined') {
      toReturn['externalId'] = this.externalId;
    }
    if (typeof this.categoryType !== 'undefined') {
      toReturn['categoryType'] = this.categoryType;
    }
    return toReturn;
  }
}
class DeleteCategoryRelationshipByOriginAndTargetRequest {
  static fromProto(proto) {
    let m = new DeleteCategoryRelationshipByOriginAndTargetRequest();
    m = Object.assign(m, proto);
    if (proto.origin) {
      m.origin = DeleteCategoryRelationshipByOriginAndTargetRequestIdentifier.fromProto(proto.origin);
    }
    if (proto.target) {
      m.target = DeleteCategoryRelationshipByOriginAndTargetRequestIdentifier.fromProto(proto.target);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.origin !== 'undefined' && this.origin !== null) {
      toReturn['origin'] = 'toApiJson' in this.origin ? this.origin.toApiJson() : this.origin;
    }
    if (typeof this.target !== 'undefined' && this.target !== null) {
      toReturn['target'] = 'toApiJson' in this.target ? this.target.toApiJson() : this.target;
    }
    return toReturn;
  }
}
class DeleteSuggestedMappingsRequest {
  static fromProto(proto) {
    let m = new DeleteSuggestedMappingsRequest();
    m = Object.assign(m, proto);
    if (proto.originType) {
      m.originType = enumStringToValue(CategoryType, proto.originType);
    }
    if (proto.targetType) {
      m.targetType = enumStringToValue(CategoryType, proto.targetType);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.originType !== 'undefined') {
      toReturn['originType'] = this.originType;
    }
    if (typeof this.targetType !== 'undefined') {
      toReturn['targetType'] = this.targetType;
    }
    if (typeof this.originId !== 'undefined') {
      toReturn['originId'] = this.originId;
    }
    return toReturn;
  }
}
class ValidateVCategoriesResponseErrorsEntry {
  static fromProto(proto) {
    let m = new ValidateVCategoriesResponseErrorsEntry();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.key !== 'undefined') {
      toReturn['key'] = this.key;
    }
    if (typeof this.value !== 'undefined') {
      toReturn['value'] = this.value;
    }
    return toReturn;
  }
}
class GenerateCategoryTrainingDataRequest {
  static fromProto(proto) {
    let m = new GenerateCategoryTrainingDataRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.startTuningWorkflow !== 'undefined') {
      toReturn['startTuningWorkflow'] = this.startTuningWorkflow;
    }
    return toReturn;
  }
}
class GetAllCategoryMappingsRequest {
  static fromProto(proto) {
    let m = new GetAllCategoryMappingsRequest();
    m = Object.assign(m, proto);
    if (proto.categoryType) {
      m.categoryType = enumStringToValue(CategoryType, proto.categoryType);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.externalId !== 'undefined') {
      toReturn['externalId'] = this.externalId;
    }
    if (typeof this.categoryType !== 'undefined') {
      toReturn['categoryType'] = this.categoryType;
    }
    return toReturn;
  }
}
class GetAllCategoryMappingsResponse {
  static fromProto(proto) {
    let m = new GetAllCategoryMappingsResponse();
    m = Object.assign(m, proto);
    if (proto.origins) {
      m.origins = proto.origins.map(Category.fromProto);
    }
    if (proto.targets) {
      m.targets = proto.targets.map(Category.fromProto);
    }
    if (proto.relationships) {
      m.relationships = proto.relationships.map(CategoryRelationships.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.origins !== 'undefined' && this.origins !== null) {
      toReturn['origins'] = 'toApiJson' in this.origins ? this.origins.toApiJson() : this.origins;
    }
    if (typeof this.targets !== 'undefined' && this.targets !== null) {
      toReturn['targets'] = 'toApiJson' in this.targets ? this.targets.toApiJson() : this.targets;
    }
    if (typeof this.relationships !== 'undefined' && this.relationships !== null) {
      toReturn['relationships'] = 'toApiJson' in this.relationships ? this.relationships.toApiJson() : this.relationships;
    }
    return toReturn;
  }
}
class GetCategoryByExternalIDsAndTypeRequest {
  static fromProto(proto) {
    let m = new GetCategoryByExternalIDsAndTypeRequest();
    m = Object.assign(m, proto);
    if (proto.categories) {
      m.categories = proto.categories.map(CategoryRequest.fromProto);
    }
    if (proto.languageAndLocale) {
      m.languageAndLocale = enumStringToValue(Locale, proto.languageAndLocale);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.categories !== 'undefined' && this.categories !== null) {
      toReturn['categories'] = 'toApiJson' in this.categories ? this.categories.toApiJson() : this.categories;
    }
    if (typeof this.locale !== 'undefined') {
      toReturn['locale'] = this.locale;
    }
    if (typeof this.languageAndLocale !== 'undefined') {
      toReturn['languageAndLocale'] = this.languageAndLocale;
    }
    return toReturn;
  }
}
class GetCategoryByExternalIDsAndTypeResponse {
  static fromProto(proto) {
    let m = new GetCategoryByExternalIDsAndTypeResponse();
    m = Object.assign(m, proto);
    if (proto.category) {
      m.category = proto.category.map(Category.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.category !== 'undefined' && this.category !== null) {
      toReturn['category'] = 'toApiJson' in this.category ? this.category.toApiJson() : this.category;
    }
    return toReturn;
  }
}
class GetCategoryByNameAndTypeRequest {
  static fromProto(proto) {
    let m = new GetCategoryByNameAndTypeRequest();
    m = Object.assign(m, proto);
    if (proto.categoryType) {
      m.categoryType = enumStringToValue(CategoryType, proto.categoryType);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.categoryName !== 'undefined') {
      toReturn['categoryName'] = this.categoryName;
    }
    if (typeof this.categoryType !== 'undefined') {
      toReturn['categoryType'] = this.categoryType;
    }
    if (typeof this.locale !== 'undefined') {
      toReturn['locale'] = this.locale;
    }
    return toReturn;
  }
}
class GetCategoryByNameAndTypeResponse {
  static fromProto(proto) {
    let m = new GetCategoryByNameAndTypeResponse();
    m = Object.assign(m, proto);
    if (proto.category) {
      m.category = Category.fromProto(proto.category);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.category !== 'undefined' && this.category !== null) {
      toReturn['category'] = 'toApiJson' in this.category ? this.category.toApiJson() : this.category;
    }
    return toReturn;
  }
}
class GetCategoryListRequest {
  static fromProto(proto) {
    let m = new GetCategoryListRequest();
    m = Object.assign(m, proto);
    if (proto.type) {
      m.type = enumStringToValue(CategoryType, proto.type);
    }
    if (proto.pagingOptions) {
      m.pagingOptions = CategoryPagedRequestOptions.fromProto(proto.pagingOptions);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.type !== 'undefined') {
      toReturn['type'] = this.type;
    }
    if (typeof this.pagingOptions !== 'undefined' && this.pagingOptions !== null) {
      toReturn['pagingOptions'] = 'toApiJson' in this.pagingOptions ? this.pagingOptions.toApiJson() : this.pagingOptions;
    }
    if (typeof this.locale !== 'undefined') {
      toReturn['locale'] = this.locale;
    }
    return toReturn;
  }
}
class GetCategoryListResponse {
  static fromProto(proto) {
    let m = new GetCategoryListResponse();
    m = Object.assign(m, proto);
    if (proto.category) {
      m.category = proto.category.map(Category.fromProto);
    }
    if (proto.pagingMetadata) {
      m.pagingMetadata = CategoryPagedResponseMetadata.fromProto(proto.pagingMetadata);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.category !== 'undefined' && this.category !== null) {
      toReturn['category'] = 'toApiJson' in this.category ? this.category.toApiJson() : this.category;
    }
    if (typeof this.pagingMetadata !== 'undefined' && this.pagingMetadata !== null) {
      toReturn['pagingMetadata'] = 'toApiJson' in this.pagingMetadata ? this.pagingMetadata.toApiJson() : this.pagingMetadata;
    }
    return toReturn;
  }
}
class GetCategoryMappingRequest {
  static fromProto(proto) {
    let m = new GetCategoryMappingRequest();
    m = Object.assign(m, proto);
    if (proto.inputType) {
      m.inputType = enumStringToValue(CategoryType, proto.inputType);
    }
    if (proto.outputType) {
      m.outputType = enumStringToValue(CategoryType, proto.outputType);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.externalId !== 'undefined') {
      toReturn['externalId'] = this.externalId;
    }
    if (typeof this.inputType !== 'undefined') {
      toReturn['inputType'] = this.inputType;
    }
    if (typeof this.outputType !== 'undefined') {
      toReturn['outputType'] = this.outputType;
    }
    if (typeof this.locale !== 'undefined') {
      toReturn['locale'] = this.locale;
    }
    return toReturn;
  }
}
class GetCategoryMappingResponse {
  static fromProto(proto) {
    let m = new GetCategoryMappingResponse();
    m = Object.assign(m, proto);
    if (proto.category) {
      m.category = Category.fromProto(proto.category);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.category !== 'undefined' && this.category !== null) {
      toReturn['category'] = 'toApiJson' in this.category ? this.category.toApiJson() : this.category;
    }
    return toReturn;
  }
}
class GetCategoryRequest {
  static fromProto(proto) {
    let m = new GetCategoryRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.categoryId !== 'undefined') {
      toReturn['categoryId'] = this.categoryId;
    }
    if (typeof this.locale !== 'undefined') {
      toReturn['locale'] = this.locale;
    }
    return toReturn;
  }
}
class GetCategoryResponse {
  static fromProto(proto) {
    let m = new GetCategoryResponse();
    m = Object.assign(m, proto);
    if (proto.category) {
      m.category = Category.fromProto(proto.category);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.category !== 'undefined' && this.category !== null) {
      toReturn['category'] = 'toApiJson' in this.category ? this.category.toApiJson() : this.category;
    }
    return toReturn;
  }
}
class GetMappingManagementDataRequest {
  static fromProto(proto) {
    let m = new GetMappingManagementDataRequest();
    m = Object.assign(m, proto);
    if (proto.originType) {
      m.originType = enumStringToValue(CategoryType, proto.originType);
    }
    if (proto.targetType) {
      m.targetType = enumStringToValue(CategoryType, proto.targetType);
    }
    if (proto.sortOptions) {
      m.sortOptions = proto.sortOptions.map(SortOptions.fromProto);
    }
    if (proto.pagingOptions) {
      m.pagingOptions = PagedRequestOptions.fromProto(proto.pagingOptions);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.searchTerm !== 'undefined') {
      toReturn['searchTerm'] = this.searchTerm;
    }
    if (typeof this.originType !== 'undefined') {
      toReturn['originType'] = this.originType;
    }
    if (typeof this.targetType !== 'undefined') {
      toReturn['targetType'] = this.targetType;
    }
    if (typeof this.sortOptions !== 'undefined' && this.sortOptions !== null) {
      toReturn['sortOptions'] = 'toApiJson' in this.sortOptions ? this.sortOptions.toApiJson() : this.sortOptions;
    }
    if (typeof this.pagingOptions !== 'undefined' && this.pagingOptions !== null) {
      toReturn['pagingOptions'] = 'toApiJson' in this.pagingOptions ? this.pagingOptions.toApiJson() : this.pagingOptions;
    }
    return toReturn;
  }
}
class GetMappingManagementDataResponse {
  static fromProto(proto) {
    let m = new GetMappingManagementDataResponse();
    m = Object.assign(m, proto);
    if (proto.data) {
      m.data = proto.data.map(MappingManagementData.fromProto);
    }
    if (proto.pagingMetadata) {
      m.pagingMetadata = PagedResponseMetadata.fromProto(proto.pagingMetadata);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.data !== 'undefined' && this.data !== null) {
      toReturn['data'] = 'toApiJson' in this.data ? this.data.toApiJson() : this.data;
    }
    if (typeof this.pagingMetadata !== 'undefined' && this.pagingMetadata !== null) {
      toReturn['pagingMetadata'] = 'toApiJson' in this.pagingMetadata ? this.pagingMetadata.toApiJson() : this.pagingMetadata;
    }
    return toReturn;
  }
}
class GetMultiCategoryMappingRequest {
  static fromProto(proto) {
    let m = new GetMultiCategoryMappingRequest();
    m = Object.assign(m, proto);
    if (proto.inputType) {
      m.inputType = enumStringToValue(CategoryType, proto.inputType);
    }
    if (proto.outputType) {
      m.outputType = enumStringToValue(CategoryType, proto.outputType);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.externalIds !== 'undefined') {
      toReturn['externalIds'] = this.externalIds;
    }
    if (typeof this.inputType !== 'undefined') {
      toReturn['inputType'] = this.inputType;
    }
    if (typeof this.outputType !== 'undefined') {
      toReturn['outputType'] = this.outputType;
    }
    if (typeof this.locale !== 'undefined') {
      toReturn['locale'] = this.locale;
    }
    return toReturn;
  }
}
class GetMultiCategoryMappingResponse {
  static fromProto(proto) {
    let m = new GetMultiCategoryMappingResponse();
    m = Object.assign(m, proto);
    if (proto.category) {
      m.category = proto.category.map(Category.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.category !== 'undefined' && this.category !== null) {
      toReturn['category'] = 'toApiJson' in this.category ? this.category.toApiJson() : this.category;
    }
    return toReturn;
  }
}
class GetSuggestedMappingsForCategoryRequest {
  static fromProto(proto) {
    let m = new GetSuggestedMappingsForCategoryRequest();
    m = Object.assign(m, proto);
    if (proto.originType) {
      m.originType = enumStringToValue(CategoryType, proto.originType);
    }
    if (proto.targetType) {
      m.targetType = enumStringToValue(CategoryType, proto.targetType);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.originType !== 'undefined') {
      toReturn['originType'] = this.originType;
    }
    if (typeof this.targetType !== 'undefined') {
      toReturn['targetType'] = this.targetType;
    }
    if (typeof this.originId !== 'undefined') {
      toReturn['originId'] = this.originId;
    }
    return toReturn;
  }
}
class GetSuggestedMappingsForCategoryResponse {
  static fromProto(proto) {
    let m = new GetSuggestedMappingsForCategoryResponse();
    m = Object.assign(m, proto);
    if (proto.suggestions) {
      m.suggestions = proto.suggestions.map(SuggestedMappingTarget.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.suggestions !== 'undefined' && this.suggestions !== null) {
      toReturn['suggestions'] = 'toApiJson' in this.suggestions ? this.suggestions.toApiJson() : this.suggestions;
    }
    return toReturn;
  }
}
class DeleteCategoryRelationshipByOriginAndTargetRequestIdentifier {
  static fromProto(proto) {
    let m = new DeleteCategoryRelationshipByOriginAndTargetRequestIdentifier();
    m = Object.assign(m, proto);
    if (proto.categoryType) {
      m.categoryType = enumStringToValue(CategoryType, proto.categoryType);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.externalId !== 'undefined') {
      toReturn['externalId'] = this.externalId;
    }
    if (typeof this.categoryType !== 'undefined') {
      toReturn['categoryType'] = this.categoryType;
    }
    return toReturn;
  }
}
class ListSuggestedMappingsForCategoryTypeRequest {
  static fromProto(proto) {
    let m = new ListSuggestedMappingsForCategoryTypeRequest();
    m = Object.assign(m, proto);
    if (proto.originType) {
      m.originType = enumStringToValue(CategoryType, proto.originType);
    }
    if (proto.targetType) {
      m.targetType = enumStringToValue(CategoryType, proto.targetType);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.originType !== 'undefined') {
      toReturn['originType'] = this.originType;
    }
    if (typeof this.targetType !== 'undefined') {
      toReturn['targetType'] = this.targetType;
    }
    return toReturn;
  }
}
class ListSuggestedMappingsForCategoryTypeResponse {
  static fromProto(proto) {
    let m = new ListSuggestedMappingsForCategoryTypeResponse();
    m = Object.assign(m, proto);
    if (proto.suggestions) {
      m.suggestions = proto.suggestions.map(SuggestedMappings.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.suggestions !== 'undefined' && this.suggestions !== null) {
      toReturn['suggestions'] = 'toApiJson' in this.suggestions ? this.suggestions.toApiJson() : this.suggestions;
    }
    return toReturn;
  }
}
class UpdateCategoryMappingsV2RequestMapping {
  static fromProto(proto) {
    let m = new UpdateCategoryMappingsV2RequestMapping();
    m = Object.assign(m, proto);
    if (proto.targetType) {
      m.targetType = enumStringToValue(CategoryType, proto.targetType);
    }
    if (proto.relationship) {
      m.relationship = enumStringToValue(TypeCategoryRelationship, proto.relationship);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.originId !== 'undefined') {
      toReturn['originId'] = this.originId;
    }
    if (typeof this.targetType !== 'undefined') {
      toReturn['targetType'] = this.targetType;
    }
    if (typeof this.targetId !== 'undefined') {
      toReturn['targetId'] = this.targetId;
    }
    if (typeof this.relationship !== 'undefined') {
      toReturn['relationship'] = this.relationship;
    }
    if (typeof this.humanVerified !== 'undefined') {
      toReturn['humanVerified'] = this.humanVerified;
    }
    return toReturn;
  }
}
class MappingManagementData {
  static fromProto(proto) {
    let m = new MappingManagementData();
    m = Object.assign(m, proto);
    if (proto.origin) {
      m.origin = Category.fromProto(proto.origin);
    }
    if (proto.targetType) {
      m.targetType = enumStringToValue(CategoryType, proto.targetType);
    }
    if (proto.targets) {
      m.targets = proto.targets.map(Category.fromProto);
    }
    if (proto.relationship) {
      m.relationship = enumStringToValue(TypeCategoryRelationship, proto.relationship);
    }
    if (proto.suggestions) {
      m.suggestions = proto.suggestions.map(SuggestedMappingTarget.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.origin !== 'undefined' && this.origin !== null) {
      toReturn['origin'] = 'toApiJson' in this.origin ? this.origin.toApiJson() : this.origin;
    }
    if (typeof this.targetType !== 'undefined') {
      toReturn['targetType'] = this.targetType;
    }
    if (typeof this.targets !== 'undefined' && this.targets !== null) {
      toReturn['targets'] = 'toApiJson' in this.targets ? this.targets.toApiJson() : this.targets;
    }
    if (typeof this.relationship !== 'undefined') {
      toReturn['relationship'] = this.relationship;
    }
    if (typeof this.suggestions !== 'undefined' && this.suggestions !== null) {
      toReturn['suggestions'] = 'toApiJson' in this.suggestions ? this.suggestions.toApiJson() : this.suggestions;
    }
    return toReturn;
  }
}
class UpdateCategoryMappingsRequestMappings {
  static fromProto(proto) {
    let m = new UpdateCategoryMappingsRequestMappings();
    m = Object.assign(m, proto);
    if (proto.relationship) {
      m.relationship = enumStringToValue(TypeCategoryRelationship, proto.relationship);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.referencesId !== 'undefined') {
      toReturn['referencesId'] = this.referencesId;
    }
    if (typeof this.referencedById !== 'undefined') {
      toReturn['referencedById'] = this.referencedById;
    }
    if (typeof this.relationship !== 'undefined') {
      toReturn['relationship'] = this.relationship;
    }
    return toReturn;
  }
}
class SortOptions {
  static fromProto(proto) {
    let m = new SortOptions();
    m = Object.assign(m, proto);
    if (proto.field) {
      m.field = enumStringToValue(SortField, proto.field);
    }
    if (proto.direction) {
      m.direction = enumStringToValue(SortDirection, proto.direction);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.field !== 'undefined') {
      toReturn['field'] = this.field;
    }
    if (typeof this.direction !== 'undefined') {
      toReturn['direction'] = this.direction;
    }
    return toReturn;
  }
}
class StartCategoryEmbeddingWorkflowRequest {
  static fromProto(proto) {
    let m = new StartCategoryEmbeddingWorkflowRequest();
    m = Object.assign(m, proto);
    if (proto.types) {
      m.types = proto.types.map(v => enumStringToValue(CategoryType, v));
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.types !== 'undefined') {
      toReturn['types'] = this.types;
    }
    if (typeof this.updateExisting !== 'undefined') {
      toReturn['updateExisting'] = this.updateExisting;
    }
    return toReturn;
  }
}
class StartCategoryMappingWorkflowRequest {
  static fromProto(proto) {
    let m = new StartCategoryMappingWorkflowRequest();
    m = Object.assign(m, proto);
    if (proto.originType) {
      m.originType = enumStringToValue(CategoryType, proto.originType);
    }
    if (proto.targetType) {
      m.targetType = enumStringToValue(CategoryType, proto.targetType);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.originType !== 'undefined') {
      toReturn['originType'] = this.originType;
    }
    if (typeof this.targetType !== 'undefined') {
      toReturn['targetType'] = this.targetType;
    }
    return toReturn;
  }
}
class SuggestedMappingTarget {
  static fromProto(proto) {
    let m = new SuggestedMappingTarget();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.fullName !== 'undefined') {
      toReturn['fullName'] = this.fullName;
    }
    if (typeof this.score !== 'undefined') {
      toReturn['score'] = this.score;
    }
    return toReturn;
  }
}
class SuggestedMappings {
  static fromProto(proto) {
    let m = new SuggestedMappings();
    m = Object.assign(m, proto);
    if (proto.originType) {
      m.originType = enumStringToValue(CategoryType, proto.originType);
    }
    if (proto.targetType) {
      m.targetType = enumStringToValue(CategoryType, proto.targetType);
    }
    if (proto.targets) {
      m.targets = proto.targets.map(SuggestedMappingTarget.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.originType !== 'undefined') {
      toReturn['originType'] = this.originType;
    }
    if (typeof this.targetType !== 'undefined') {
      toReturn['targetType'] = this.targetType;
    }
    if (typeof this.originId !== 'undefined') {
      toReturn['originId'] = this.originId;
    }
    if (typeof this.targets !== 'undefined' && this.targets !== null) {
      toReturn['targets'] = 'toApiJson' in this.targets ? this.targets.toApiJson() : this.targets;
    }
    return toReturn;
  }
}
class UpdateCategoryMappingsRequest {
  static fromProto(proto) {
    let m = new UpdateCategoryMappingsRequest();
    m = Object.assign(m, proto);
    if (proto.create) {
      m.create = UpdateCategoryMappingsRequestMappings.fromProto(proto.create);
    }
    if (proto.delete) {
      m.delete = UpdateCategoryMappingsRequestMappings.fromProto(proto.delete);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.categoryId !== 'undefined') {
      toReturn['categoryId'] = this.categoryId;
    }
    if (typeof this.create !== 'undefined' && this.create !== null) {
      toReturn['create'] = 'toApiJson' in this.create ? this.create.toApiJson() : this.create;
    }
    if (typeof this.delete !== 'undefined' && this.delete !== null) {
      toReturn['delete'] = 'toApiJson' in this.delete ? this.delete.toApiJson() : this.delete;
    }
    if (typeof this.humanVerified !== 'undefined') {
      toReturn['humanVerified'] = this.humanVerified;
    }
    return toReturn;
  }
}
class UpdateCategoryMappingsV2Request {
  static fromProto(proto) {
    let m = new UpdateCategoryMappingsV2Request();
    m = Object.assign(m, proto);
    if (proto.mappings) {
      m.mappings = proto.mappings.map(UpdateCategoryMappingsV2RequestMapping.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.mappings !== 'undefined' && this.mappings !== null) {
      toReturn['mappings'] = 'toApiJson' in this.mappings ? this.mappings.toApiJson() : this.mappings;
    }
    return toReturn;
  }
}
class UpdateCategoryRequest {
  static fromProto(proto) {
    let m = new UpdateCategoryRequest();
    m = Object.assign(m, proto);
    if (proto.updateFields) {
      m.updateFields = UpdateCategoryRequestUpdateFields.fromProto(proto.updateFields);
    }
    if (proto.fieldMask) {
      m.fieldMask = FieldMask.fromProto(proto.fieldMask);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.categoryId !== 'undefined') {
      toReturn['categoryId'] = this.categoryId;
    }
    if (typeof this.updateFields !== 'undefined' && this.updateFields !== null) {
      toReturn['updateFields'] = 'toApiJson' in this.updateFields ? this.updateFields.toApiJson() : this.updateFields;
    }
    if (typeof this.fieldMask !== 'undefined' && this.fieldMask !== null) {
      toReturn['fieldMask'] = 'toApiJson' in this.fieldMask ? this.fieldMask.toApiJson() : this.fieldMask;
    }
    return toReturn;
  }
}
class UpdateCategoryRequestUpdateFields {
  static fromProto(proto) {
    let m = new UpdateCategoryRequestUpdateFields();
    m = Object.assign(m, proto);
    if (proto.translations) {
      m.translations = proto.translations.map(CategoryTranslation.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.fullName !== 'undefined') {
      toReturn['fullName'] = this.fullName;
    }
    if (typeof this.isActive !== 'undefined') {
      toReturn['isActive'] = this.isActive;
    }
    if (typeof this.isHidden !== 'undefined') {
      toReturn['isHidden'] = this.isHidden;
    }
    if (typeof this.translations !== 'undefined' && this.translations !== null) {
      toReturn['translations'] = 'toApiJson' in this.translations ? this.translations.toApiJson() : this.translations;
    }
    if (typeof this.externalId !== 'undefined') {
      toReturn['externalId'] = this.externalId;
    }
    return toReturn;
  }
}
class ValidateCategoryRequest {
  static fromProto(proto) {
    let m = new ValidateCategoryRequest();
    m = Object.assign(m, proto);
    if (proto.category) {
      m.category = Category.fromProto(proto.category);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.category !== 'undefined' && this.category !== null) {
      toReturn['category'] = 'toApiJson' in this.category ? this.category.toApiJson() : this.category;
    }
    return toReturn;
  }
}
class ValidateCategoryResponse {
  static fromProto(proto) {
    let m = new ValidateCategoryResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.isValid !== 'undefined') {
      toReturn['isValid'] = this.isValid;
    }
    return toReturn;
  }
}
class ValidateVCategoriesRequest {
  static fromProto(proto) {
    let m = new ValidateVCategoriesRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.externalIds !== 'undefined') {
      toReturn['externalIds'] = this.externalIds;
    }
    return toReturn;
  }
}
class ValidateVCategoriesResponse {
  static fromProto(proto) {
    let m = new ValidateVCategoriesResponse();
    m = Object.assign(m, proto);
    if (proto.errors) {
      m.errors = Object.keys(proto.errors).reduce((obj, k) => {
        obj[k] = proto.errors[k];
        return obj;
      }, {});
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.errors !== 'undefined' && this.errors !== null) {
      toReturn['errors'] = 'toApiJson' in this.errors ? this.errors.toApiJson() : this.errors;
    }
    return toReturn;
  }
}

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Objects Index.
// *********************************

const environment = (window ? window['environment'] : 'prod') ?? 'prod';
const hostMap = {
  'local': 'category-api.vendasta-local.com',
  'test': '',
  'demo': 'category-demo.apigateway.co',
  'prod': 'category-prod.apigateway.co',
  'production': 'category-prod.apigateway.co'
};
let HostService = /*#__PURE__*/(() => {
  class HostService {
    get host() {
      return hostMap[environment.toLowerCase()];
    }
    get hostWithScheme() {
      return 'https://' + this.host;
    }
  }
  HostService.ɵfac = function HostService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || HostService)();
  };
  HostService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: HostService,
    factory: HostService.ɵfac,
    providedIn: 'root'
  });
  return HostService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let CategoriesApiService = /*#__PURE__*/(() => {
  class CategoriesApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    getCategory(r) {
      const request = r.toApiJson ? r : new GetCategoryRequest(r);
      return this.http.post(this._host + "/category.v1.Categories/GetCategory", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetCategoryResponse.fromProto(resp)));
    }
    getCategoryList(r) {
      const request = r.toApiJson ? r : new GetCategoryListRequest(r);
      return this.http.post(this._host + "/category.v1.Categories/GetCategoryList", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetCategoryListResponse.fromProto(resp)));
    }
    getCategoryMapping(r) {
      const request = r.toApiJson ? r : new GetCategoryMappingRequest(r);
      return this.http.post(this._host + "/category.v1.Categories/GetCategoryMapping", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetCategoryMappingResponse.fromProto(resp)));
    }
    bulkCreateCategories(r) {
      const request = r.toApiJson ? r : new BulkCreateCategoriesRequest(r);
      return this.http.post(this._host + "/category.v1.Categories/BulkCreateCategories", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    bulkCreateCategoryRelationships(r) {
      const request = r.toApiJson ? r : new BulkCreateCategoryRelationshipsRequest(r);
      return this.http.post(this._host + "/category.v1.Categories/BulkCreateCategoryRelationships", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    bulkDeleteCategoryRelationships(r) {
      const request = r.toApiJson ? r : new BulkDeleteCategoryRelationshipsRequest(r);
      return this.http.post(this._host + "/category.v1.Categories/BulkDeleteCategoryRelationships", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    validateCategory(r) {
      const request = r.toApiJson ? r : new ValidateCategoryRequest(r);
      return this.http.post(this._host + "/category.v1.Categories/ValidateCategory", request.toApiJson(), this.apiOptions()).pipe(map(resp => ValidateCategoryResponse.fromProto(resp)));
    }
    getCategoryByNameAndType(r) {
      const request = r.toApiJson ? r : new GetCategoryByNameAndTypeRequest(r);
      return this.http.post(this._host + "/category.v1.Categories/GetCategoryByNameAndType", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetCategoryByNameAndTypeResponse.fromProto(resp)));
    }
    deleteCategoryByExternalIdAndType(r) {
      const request = r.toApiJson ? r : new DeleteCategoryByExternalIDAndTypeRequest(r);
      return this.http.post(this._host + "/category.v1.Categories/DeleteCategoryByExternalIDAndType", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    deleteCategoryRelationshipByExternalIdAndType(r) {
      const request = r.toApiJson ? r : new DeleteCategoryRelationshipByExternalIDAndTypeRequest(r);
      return this.http.post(this._host + "/category.v1.Categories/DeleteCategoryRelationshipByExternalIDAndType", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    getCategoryByExternalIDsAndType(r) {
      const request = r.toApiJson ? r : new GetCategoryByExternalIDsAndTypeRequest(r);
      return this.http.post(this._host + "/category.v1.Categories/GetCategoryByExternalIDsAndType", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetCategoryByExternalIDsAndTypeResponse.fromProto(resp)));
    }
    getMultiCategoryMapping(r) {
      const request = r.toApiJson ? r : new GetMultiCategoryMappingRequest(r);
      return this.http.post(this._host + "/category.v1.Categories/GetMultiCategoryMapping", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetMultiCategoryMappingResponse.fromProto(resp)));
    }
    getCategoryBySearchTerm(r) {
      const request = r.toApiJson ? r : new CategorySearchRequest(r);
      return this.http.post(this._host + "/category.v1.Categories/GetCategoryBySearchTerm", request.toApiJson(), this.apiOptions()).pipe(map(resp => CategorySearchResponse.fromProto(resp)));
    }
    deleteCategoryRelationshipByOriginAndTarget(r) {
      const request = r.toApiJson ? r : new DeleteCategoryRelationshipByOriginAndTargetRequest(r);
      return this.http.post(this._host + "/category.v1.Categories/DeleteCategoryRelationshipByOriginAndTarget", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    updateCategory(r) {
      const request = r.toApiJson ? r : new UpdateCategoryRequest(r);
      return this.http.post(this._host + "/category.v1.Categories/UpdateCategory", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    createCategory(r) {
      const request = r.toApiJson ? r : new CreateCategoryRequest(r);
      return this.http.post(this._host + "/category.v1.Categories/CreateCategory", request.toApiJson(), this.apiOptions()).pipe(map(resp => CreateCategoryResponse.fromProto(resp)));
    }
    getAllCategoryMappings(r) {
      const request = r.toApiJson ? r : new GetAllCategoryMappingsRequest(r);
      return this.http.post(this._host + "/category.v1.Categories/GetAllCategoryMappings", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetAllCategoryMappingsResponse.fromProto(resp)));
    }
    updateCategoryMappings(r) {
      const request = r.toApiJson ? r : new UpdateCategoryMappingsRequest(r);
      return this.http.post(this._host + "/category.v1.Categories/UpdateCategoryMappings", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    updateCategoryMappingsV2(r) {
      const request = r.toApiJson ? r : new UpdateCategoryMappingsV2Request(r);
      return this.http.post(this._host + "/category.v1.Categories/UpdateCategoryMappingsV2", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    startCategoryEmbeddingWorkflow(r) {
      const request = r.toApiJson ? r : new StartCategoryEmbeddingWorkflowRequest(r);
      return this.http.post(this._host + "/category.v1.Categories/StartCategoryEmbeddingWorkflow", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    startCategoryMappingWorkflow(r) {
      const request = r.toApiJson ? r : new StartCategoryMappingWorkflowRequest(r);
      return this.http.post(this._host + "/category.v1.Categories/StartCategoryMappingWorkflow", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    generateCategoryTrainingData(r) {
      const request = r.toApiJson ? r : new GenerateCategoryTrainingDataRequest(r);
      return this.http.post(this._host + "/category.v1.Categories/GenerateCategoryTrainingData", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    listSuggestedMappingsForCategoryType(r) {
      const request = r.toApiJson ? r : new ListSuggestedMappingsForCategoryTypeRequest(r);
      return this.http.post(this._host + "/category.v1.Categories/ListSuggestedMappingsForCategoryType", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListSuggestedMappingsForCategoryTypeResponse.fromProto(resp)));
    }
    getSuggestedMappingsForCategory(r) {
      const request = r.toApiJson ? r : new GetSuggestedMappingsForCategoryRequest(r);
      return this.http.post(this._host + "/category.v1.Categories/GetSuggestedMappingsForCategory", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetSuggestedMappingsForCategoryResponse.fromProto(resp)));
    }
    getMappingManagementData(r) {
      const request = r.toApiJson ? r : new GetMappingManagementDataRequest(r);
      return this.http.post(this._host + "/category.v1.Categories/GetMappingManagementData", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetMappingManagementDataResponse.fromProto(resp)));
    }
    deleteSuggestedMappings(r) {
      const request = r.toApiJson ? r : new DeleteSuggestedMappingsRequest(r);
      return this.http.post(this._host + "/category.v1.Categories/DeleteSuggestedMappings", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
  }
  CategoriesApiService.ɵfac = function CategoriesApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || CategoriesApiService)();
  };
  CategoriesApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: CategoriesApiService,
    factory: CategoriesApiService.ɵfac,
    providedIn: 'root'
  });
  return CategoriesApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let VCategoryValidationApiService = /*#__PURE__*/(() => {
  class VCategoryValidationApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    validateVCategories(r) {
      const request = r.toApiJson ? r : new ValidateVCategoriesRequest(r);
      return this.http.post(this._host + "/category.v1.VCategoryValidation/ValidateVCategories", request.toApiJson(), this.apiOptions()).pipe(map(resp => ValidateVCategoriesResponse.fromProto(resp)));
    }
  }
  VCategoryValidationApiService.ɵfac = function VCategoryValidationApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || VCategoryValidationApiService)();
  };
  VCategoryValidationApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: VCategoryValidationApiService,
    factory: VCategoryValidationApiService.ɵfac,
    providedIn: 'root'
  });
  return VCategoryValidationApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Index.
// *********************************
let CategoryService = /*#__PURE__*/(() => {
  class CategoryService {
    constructor(_api) {
      this._api = _api;
    }
    getCategory(categoryId) {
      return this._api.getCategory({
        categoryId: categoryId
      }).pipe(map(res => res.category));
    }
    getCategoryByExternalIDsAndType(categories, locale) {
      return this._api.getCategoryByExternalIDsAndType({
        categories: categories,
        locale: locale
      }).pipe(map(res => res.category));
    }
    getCategoryList(type, pagingOptions) {
      return this._api.getCategoryList({
        type: type,
        pagingOptions: pagingOptions
      }).pipe(map(res => res.category));
    }
    getCategoryMapping(externalId, inputType, outputType) {
      return this._api.getCategoryMapping({
        externalId: externalId,
        inputType: inputType,
        outputType: outputType
      }).pipe(map(res => res.category));
    }
    validateCategory(category) {
      return this._api.validateCategory({
        category: category
      }).pipe(map(res => res.isValid));
    }
    getCategoryBySearchTerm(searchTerm, type, pagingOptions, sortOptions) {
      return this._api.getCategoryBySearchTerm({
        searchTerm,
        type,
        pagingOptions,
        sortOptions
      }).pipe(map(res => res.category));
    }
  }
  CategoryService.ɵfac = function CategoryService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || CategoryService)(i0.ɵɵinject(CategoriesApiService));
  };
  CategoryService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: CategoryService,
    factory: CategoryService.ɵfac,
    providedIn: 'root'
  });
  return CategoryService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const localeMap = new Map([['af', Locale.LOCALE_AFRIKAANS], ['cs', Locale.LOCALE_CZECH], ['nl', Locale.LOCALE_DUTCH], ['en', Locale.LOCALE_ENGLISH], ['fr', Locale.LOCALE_FRENCH], ['fr-ca', Locale.LOCALE_FRENCH_CANADA], ['de', Locale.LOCALE_GERMAN], ['it', Locale.LOCALE_ITALIAN], ['ja', Locale.LOCALE_JAPANESE], ['pt-br', Locale.LOCALE_PORTUGUESE_BRAZIL], ['ru', Locale.LOCALE_RUSSIAN], ['es-419', Locale.LOCALE_SPANISH_LATIN_AMERICA],
// fallback options to handle regional language codes that are not supported by the API
['es', Locale.LOCALE_SPANISH_LATIN_AMERICA], ['pt', Locale.LOCALE_PORTUGUESE_BRAZIL]]);
class CategoryUtils {
  /**
   * Convert user's language to Locale enum value
   * @param language user's language
   * @returns `Locale` enum value
   * @example CategoryUtils.localeFromLanguage('en') => Locale.LOCALE_ENGLISH
   */
  static localeFromLanguage(language) {
    const selectedLanguage = language?.toLowerCase() ?? '';
    const locale = localeMap.get(selectedLanguage);
    if (locale) {
      return locale;
    }
    // search for a fallback option based on the first slice of the language code
    const baseLanguage = selectedLanguage.split('-')[0];
    return localeMap.get(baseLanguage);
  }
}

/**
 * Generated bundle index. Do not edit.
 */

export { Access, BulkCreateCategoriesRequest, BulkCreateCategoryRelationshipsRequest, BulkDeleteCategoryRelationshipsRequest, CategoriesApiService, Category, CategoryClass, CategoryLocale, CategoryPagedRequestOptions, CategoryPagedResponseMetadata, CategoryRelationship, CategoryRelationships, CategoryRequest, CategorySearchRequest, CategorySearchResponse, CategoryService, CategoryTranslation, CategoryType, CategoryUtils, CreateCategoryRequest, CreateCategoryResponse, DeleteCategoryByExternalIDAndTypeRequest, DeleteCategoryRelationshipByExternalIDAndTypeRequest, DeleteCategoryRelationshipByOriginAndTargetRequest, DeleteCategoryRelationshipByOriginAndTargetRequestIdentifier, DeleteSuggestedMappingsRequest, FieldMask, GenerateCategoryTrainingDataRequest, GetAllCategoryMappingsRequest, GetAllCategoryMappingsResponse, GetCategoryByExternalIDsAndTypeRequest, GetCategoryByExternalIDsAndTypeResponse, GetCategoryByNameAndTypeRequest, GetCategoryByNameAndTypeResponse, GetCategoryListRequest, GetCategoryListResponse, GetCategoryMappingRequest, GetCategoryMappingResponse, GetCategoryRequest, GetCategoryResponse, GetMappingManagementDataRequest, GetMappingManagementDataResponse, GetMultiCategoryMappingRequest, GetMultiCategoryMappingResponse, GetSuggestedMappingsForCategoryRequest, GetSuggestedMappingsForCategoryResponse, ListSuggestedMappingsForCategoryTypeRequest, ListSuggestedMappingsForCategoryTypeResponse, Locale, MappingManagementData, PagedRequestOptions, PagedResponseMetadata, SortDirection, SortField, SortOptions, StartCategoryEmbeddingWorkflowRequest, StartCategoryMappingWorkflowRequest, SuggestedMappingTarget, SuggestedMappings, TypeCategoryRelationship, UpdateCategoryMappingsRequest, UpdateCategoryMappingsRequestMappings, UpdateCategoryMappingsV2Request, UpdateCategoryMappingsV2RequestMapping, UpdateCategoryRequest, UpdateCategoryRequestUpdateFields, VCategoryValidationApiService, ValidateCategoryRequest, ValidateCategoryResponse, ValidateVCategoriesRequest, ValidateVCategoriesResponse, ValidateVCategoriesResponseErrorsEntry };
